export const lineClampTwoClasses =
  'overflow-hidden break-words [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2]';

export const COLUMN_WIDTH_STORAGE_KEY = 'dataview-column-widths';
export const ACTION_COLUMN_KEY = '__action__';
export const ACTION_COLUMN_WIDTH = 120;
export const MIN_COLUMN_WIDTH = 120;
export const MAX_COLUMN_WIDTH = 900;

export const shouldCapitalizeFirstLetter = (header) => {
  const capitalizeFields = [
    'title', 'abstract', 'description', 'summary', 'brief',
    'condition', 'intervention', 'outcome', 'criteria', 'eligibility',
    'name', 'sponsor', 'location', 'city', 'country', 'state',
    'indication', 'purpose', 'objective', 'conclusion',
    'adverse', 'warning', 'precaution', 'contraindication',
    'dosage', 'administration', 'pharmacology', 'clinical',
    'background', 'method', 'result', 'discussion',
  ];

  const lowerHeader = header.toLowerCase();
  return capitalizeFields.some((field) => lowerHeader.includes(field));
};

export const formatCellText = (content, shouldCapitalize) => {
  if (!shouldCapitalize || typeof content !== 'string' || !content.length) {
    return content;
  }

  return content.charAt(0).toUpperCase() + content.slice(1);
};

export const buildColumnWidthKey = (datasetId, header) => `${datasetId}:${header}`;

export const getDefaultColumnWidth = (header) => {
  const headerLower = header.toLowerCase();

  const tinyFields = ['id', 'year', 'phase', 'type', 'status'];
  if (tinyFields.some((field) => headerLower === field || headerLower.endsWith(`_${field}`))) {
    return 110;
  }

  const shortFields = ['nct_id', 'nct', 'pmid', 'doi', 'date'];
  if (shortFields.some((field) => headerLower.includes(field))) {
    return 160;
  }

  const mediumFields = ['name', 'sponsor', 'location', 'enrollment', 'brief'];
  if (mediumFields.some((field) => headerLower.includes(field))) {
    return 250;
  }

  const largeFields = ['title', 'description', 'summary', 'condition', 'intervention', 'outcome', 'criteria', 'eligibility'];
  if (largeFields.some((field) => headerLower.includes(field))) {
    return 380;
  }

  return 220;
};

export const formatHeaderName = (header) => {
  return header
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return { type: 'text', content: '' };
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();

    if (trimmed.includes('<') && trimmed.includes('>')) {
      const stripped = trimmed
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&quot;/g, '"')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .trim();

      const strippedTrim = stripped.trim();
      if (
        (strippedTrim.startsWith('[') && strippedTrim.endsWith(']')) ||
        (strippedTrim.startsWith('{') && strippedTrim.endsWith('}'))
      ) {
        try {
          const parsed = JSON.parse(stripped);
          if (
            typeof parsed === 'object' &&
            parsed !== null &&
            (Array.isArray(parsed) || Object.keys(parsed).length > 0)
          ) {
            return { type: 'nested', content: parsed };
          }
        } catch (error) {
          return { type: 'text', content: stripped || '' };
        }
      }

      return { type: 'text', content: stripped || '' };
    }

    if (
      (trimmed.startsWith('[') && trimmed.endsWith(']')) ||
      (trimmed.startsWith('{') && trimmed.endsWith('}'))
    ) {
      try {
        const parsed = JSON.parse(value);
        if (typeof parsed === 'object' && parsed !== null) {
          if (Array.isArray(parsed)) {
            if (parsed.length > 0) {
              return { type: 'nested', content: parsed };
            }
            return { type: 'text', content: '[]' };
          }

          if (Object.keys(parsed).length > 0) {
            return { type: 'nested', content: parsed };
          }
        }
      } catch (error) {
        return { type: 'text', content: value };
      }
    }

    return { type: 'text', content: value };
  }

  if (typeof value === 'boolean') {
    return { type: 'text', content: value ? 'Yes' : 'No' };
  }

  if (typeof value === 'number') {
    return { type: 'text', content: String(value) };
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return { type: 'text', content: '' };
    }

    return { type: 'nested', content: value };
  }

  if (typeof value === 'object') {
    const keys = Object.keys(value);
    if (keys.length === 0) {
      return { type: 'text', content: '' };
    }

    return { type: 'nested', content: value };
  }

  return { type: 'text', content: String(value) };
};
